var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-auto"},[_c('button',{staticClass:"phiolet_button c16 p1b w-100",on:{"click":_vm.scheduleUpdates}},[_vm._v("\n        "+_vm._s(_vm.buttonText)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }